import { render, staticRenderFns } from "./CardOverpomp.vue?vue&type=template&id=7d96468e"
import script from "./CardOverpomp.vue?vue&type=script&lang=js"
export * from "./CardOverpomp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports